import {EActionStatus} from '@app/shared/enums/action-status.enum';
import {createReducer, on} from '@ngrx/store';
import {IAuthenticatorSetupState} from './authenticator-setup-state.model';
import {
  cancelAuthenticatorSetup,
  cancelAuthenticatorSetupError,
  cancelAuthenticatorSetupSuccess,
  loadAuthenticatorSetup,
  loadAuthenticatorSetupError,
  loadAuthenticatorSetupFailure,
  loadAuthenticatorSetupSuccess,
  resetAuthenticatorSetupState,
  verifyAuthenticatorSetup,
  verifyAuthenticatorSetupError,
  verifyAuthenticatorSetupSuccess,
} from './authenticator-setup.actions';

const initialState: IAuthenticatorSetupState = {
  response: null,
  verificationResponse: null,
  status: EActionStatus.Initial,
  failureReason: '',
  errorMessage: '',
};

export const authenticatorSetupReducer = createReducer(
  initialState,
  on(loadAuthenticatorSetup, state => ({
    ...state,
    response: null,
    verificationResponse: null,
    status: EActionStatus.Pending,
    failureReason: '',
    errorMessage: '',
  })),
  on(loadAuthenticatorSetupSuccess, (state, {response}) => ({
    ...state,
    response,
    status: EActionStatus.Success,
    failureReason: '',
    errorMessage: '',
  })),
  on(loadAuthenticatorSetupFailure, (state, {reason}) => ({
    ...state,
    response: null,
    verificationResponse: null,
    status: EActionStatus.Failure,
    failureReason: reason,
  })),
  on(loadAuthenticatorSetupError, (state, {error}) => ({
    ...state,
    response: null,
    verificationResponse: null,
    status: EActionStatus.Error,
    errorMessage: error,
  })),
  on(cancelAuthenticatorSetup, state => ({
    ...state,
    status: EActionStatus.Pending,
    failureReason: '',
    errorMessage: '',
  })),
  on(cancelAuthenticatorSetupSuccess, state => ({
    ...state,
    response: null,
    verificationResponse: null,
    status: EActionStatus.Success,
    failureReason: '',
    errorMessage: '',
  })),
  on(cancelAuthenticatorSetupError, (state, {error}) => ({
    ...state,
    status: EActionStatus.Error,
    errorMessage: error,
  })),
  on(verifyAuthenticatorSetup, state => ({
    ...state,
    status: EActionStatus.Pending,
    failureReason: '',
    errorMessage: '',
  })),
  on(verifyAuthenticatorSetupSuccess, (state, {response}) => ({
    ...state,
    response: null,
    verificationResponse: response,
    status: EActionStatus.Success,
    failureReason: '',
    errorMessage: '',
  })),
  on(verifyAuthenticatorSetupError, (state, {error}) => ({
    ...state,
    status: EActionStatus.Error,
    errorMessage: error,
  })),
  on(resetAuthenticatorSetupState, () => initialState)
);
